import { Component, OnInit } from '@angular/core';
import { UtilsModule } from '@otas/utils/utils.module';

@Component({
  selector: 'app-temple-owner-login',
  templateUrl: './temple-owner-login.component.html',
  styleUrls: ['./temple-owner-login.component.css'],
  imports: [UtilsModule]
})
export class TempleOwnerLoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  faceBookLogin() {

  }
}
